<template>
  <div class="t-btn">
    <label v-if="label !== undefined">{{ label }}</label>
    <div>
      <md-button v-for="(btn, key) in btnList" :key="key" v-show="btn !== '---'"
        class="md-raised"
        :class="{'md-primary':key === value}"
        @click="setValue(key)">{{ btn }}</md-button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['btnList', 'label', 'editTB', 'index'],
  data: () => ({
    value: ''
  }),
  mounted () {
    this.value = this.editTB
  },
  watch: {
    value: function () {
      this.$emit('btnValue', this.value, this.index)
    },
    editTB: function () {
      this.value = this.editTB
    }
  },
  methods: {
    setValue: function (btn) {
      if (this.value === btn) {
        this.value = ''
      } else {
        this.value = btn
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/style/arcadia_theme.scss';

  .t-btn {
    margin-top: 20px;
    margin-bottom: 24px;

    label {
      font-size: 16px;
    }

    button {
      margin-left: 0px;
    }
  }
</style>
